import {ThunderDispatcher} from "@nu-art/thunderstorm/frontend";
import {ModuleFE_BaseApi} from "@nu-art/thunderstorm/frontend";

export type PageListener = {
	dispatcher: ThunderDispatcher<any, any>
	module: ModuleFE_BaseApi<any>
}